import { api } from './api';

export interface ProviderCredentialField {
  name: string;
  label: string;
  type: string;
  required: boolean;
}

export interface SupportedProviderType {
  type: string;
  name: string;
  description: string;
  credentialFields: ProviderCredentialField[];
}

export interface SupportedProvider {
  type: string;
  name: string;
  supported: boolean;
  capabilities?: any;
}

export const providerTypesService = {
  /**
   * Fetch all supported provider types with credential field definitions
   */
  async getSupportedProviderTypes(): Promise<SupportedProviderType[]> {
    const response = await api.get('/api/providers/types');
    return response.data;
  },

  /**
   * Fetch all supported providers from DNS factory (includes support status)
   */
  async getAllSupportedProviders(): Promise<SupportedProvider[]> {
    // This would need a new endpoint on the backend to expose DNSProviderFactory.getSupportedProviders()
    // For now, we'll derive it from the provider types
    const providerTypes = await this.getSupportedProviderTypes();
    return providerTypes.map(providerType => ({
      type: providerType.type,
      name: providerType.name,
      supported: true, // All providers in the types endpoint are supported
      capabilities: {
        description: providerType.description,
        credentialFields: providerType.credentialFields
      }
    }));
  }
};